import { useEffect, useRef } from "react";

/**
 * Rückkehr aus dem Back-Forward-Cache (Prüfung 24.10.2026): Nach window.location.assign(<Stripe bzw. PayPal>) bleiben Sperren und
 * „busy“ absichtlich stehen, damit während des Ladens kein zweiter Abschluss startet. Kommt jemand per Zurück wieder und der Browser
 * nimmt die Seite aus dem bfcache, liefe kein Code neu und der Knopf hinge auf „Zahlung wird geöffnet …“. pageshow mit
 * event.persisted meldet genau diesen Fall; dann setzt der Rückruf Sperre und Zustand zurück.
 * Gibt die Abmeldung zurück. Ohne window (Server, Test ohne DOM) passiert nichts.
 */
export function beiBfcacheRueckkehr(rueckruf: () => void, ziel: Pick<Window, "addEventListener" | "removeEventListener"> | null = typeof window !== "undefined" ? window : null): () => void {
  if (!ziel) return () => undefined;
  const handler = (e: Event) => { if ((e as PageTransitionEvent).persisted) rueckruf(); };
  ziel.addEventListener("pageshow", handler);
  return () => ziel.removeEventListener("pageshow", handler);
}

/** Hook zu beiBfcacheRueckkehr; der Rückruf darf sich bei jedem Zeichnen ändern */
export function useBfcacheRueckkehr(rueckruf: () => void): void {
  const aktuell = useRef(rueckruf);
  aktuell.current = rueckruf;
  useEffect(() => beiBfcacheRueckkehr(() => aktuell.current()), []);
}
